<template>
  <div>分布表单</div>
</template>

<script>
	export default {
		name: "stepForm",
		data() {
			return {
				description: '将一个冗长或用户不熟悉的表单任务分成多个步骤，指导用户完成。',
			}
		},
		created() {
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/form/stepForm.vue